<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('privacyAgreement.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <p>{{ $t('privacyAgreement.p0') }}</p>
            <p>{{ $t('privacyAgreement.p1') }}</p>
            <p>{{ $t('privacyAgreement.p2') }}</p>
            <p>{{ $t('privacyAgreement.p3') }}</p>
            <h4>{{ $t('privacyAgreement.p4') }}</h4>
            <p>{{ $t('privacyAgreement.p5') }}</p>
            <p>{{ $t('privacyAgreement.p6') }}</p>
            <p>{{ $t('privacyAgreement.p7') }}</p>
            <div>{{ $t('privacyAgreement.p8') }}</div>
            <p>{{ $t('privacyAgreement.p9p0') }}<strong>{{ $t('privacyAgreement.p9p1') }}</strong>{{ $t('privacyAgreement.p9p2') }}<strong>{{ $t('privacyAgreement.p9p3') }}</strong>{{ $t('privacyAgreement.p9p4') }}<strong>{{ $t('privacyAgreement.p9p5') }}</strong>{{ $t('privacyAgreement.p9p6') }}<strong>{{ $t('privacyAgreement.p9p7') }}</strong>{{ $t('privacyAgreement.p9p8') }}<strong>{{ $t('privacyAgreement.p9p9') }}</strong>{{ $t('privacyAgreement.p9p10') }}</p>
            <p>{{ $t('privacyAgreement.p10p0') }}<strong>{{ $t('privacyAgreement.p10p1') }}</strong>{{ $t('privacyAgreement.p10p2') }}</p>
            <p>{{ $t('privacyAgreement.p11') }}</p>
            <p>{{ $t('privacyAgreement.p12p0') }}<strong>{{ $t('privacyAgreement.p12p1') }}</strong>{{ $t('privacyAgreement.p12p2') }}</p>
            <p>{{ $t('privacyAgreement.p13') }}</p>
            <p>{{ $t('privacyAgreement.p105p0') }}<strong>{{ $t('privacyAgreement.p105p1') }}</strong>{{ $t('privacyAgreement.p105p2') }}</p>
            <div>{{ $t('privacyAgreement.p14') }}</div>
            <p>{{ $t('privacyAgreement.p15p0') }}<strong>{{ $t('privacyAgreement.p15p1') }}</strong>{{ $t('privacyAgreement.p15p2') }}<strong>{{ $t('privacyAgreement.p15p3') }}</strong>{{ $t('privacyAgreement.p15p4') }}<strong>{{ $t('privacyAgreement.p15p5') }}</strong>{{ $t('privacyAgreement.p15p6') }}</p>
            <p>{{ $t('privacyAgreement.p16p0') }}<strong>{{ $t('privacyAgreement.p16p1') }}</strong>{{ $t('privacyAgreement.p16p2') }}<strong>{{ $t('privacyAgreement.p16p3') }}</strong>{{ $t('privacyAgreement.p16p4') }}</p>
            <p>{{ $t('privacyAgreement.p17') }}</p>
            <div>{{ $t('privacyAgreement.p18') }}</div>
            <p>{{ $t('privacyAgreement.p19p0') }}<strong>{{ $t('privacyAgreement.p19p1') }}</strong>{{ $t('privacyAgreement.p19p2') }}<strong>{{ $t('privacyAgreement.p19p3') }}</strong>{{ $t('privacyAgreement.p19p4') }}</p>
            <p>{{ $t('privacyAgreement.p20') }}</p>
            <div>{{ $t('privacyAgreement.p21') }}</div>
            <p>{{ $t('privacyAgreement.p22p0') }}<strong>{{ $t('privacyAgreement.p22p1') }}</strong>{{ $t('privacyAgreement.p22p2') }}<strong>{{ $t('privacyAgreement.p22p3') }}</strong>{{ $t('privacyAgreement.p22p4') }}</p>
            <p>{{ $t('privacyAgreement.p23') }}</p>
            <p>{{ $t('privacyAgreement.p24') }}</p>
            <div>{{ $t('privacyAgreement.p101') }}</div>
            <p>{{ $t('privacyAgreement.p102') }}</p>
            <div>{{ $t('privacyAgreement.p106') }}</div>
            <p>{{ $t('privacyAgreement.p107') }}</p>
            <div>{{ $t('privacyAgreement.p25') }}</div>
            <p>{{ $t('privacyAgreement.p26') }}</p>
            <p>{{ $t('privacyAgreement.p27') }}</p>
            <p>{{ $t('privacyAgreement.p28') }}</p>
            <p>{{ $t('privacyAgreement.p29') }}</p>
            <p>{{ $t('privacyAgreement.p30') }}</p>
            <p>{{ $t('privacyAgreement.p31') }}</p>
            <p>{{ $t('privacyAgreement.p32') }}</p>
            <p>{{ $t('privacyAgreement.p33') }}</p>
            <p>{{ $t('privacyAgreement.p34') }}</p>
            <p>{{ $t('privacyAgreement.p35') }}</p>
            <p>{{ $t('privacyAgreement.p36') }}</p>
            <p>{{ $t('privacyAgreement.p37') }}</p>
            <h4>{{ $t('privacyAgreement.p38') }}</h4>
            <div>{{ $t('privacyAgreement.p39') }}</div>
            <p>{{ $t('privacyAgreement.p40') }}</p>
            <div>{{ $t('privacyAgreement.p41') }}</div>
            <p>{{ $t('privacyAgreement.p42') }}</p>
            <p>{{ $t('privacyAgreement.p43') }}</p>
            <p>{{ $t('privacyAgreement.p44') }}</p>
            <div>{{ $t('privacyAgreement.p45') }}</div>
            <p>{{ $t('privacyAgreement.p46') }}</p>
            <p>{{ $t('privacyAgreement.p47') }}</p>
            <p>{{ $t('privacyAgreement.p48') }}</p>
            <div>{{ $t('privacyAgreement.p49') }}</div>
            <p>{{ $t('privacyAgreement.p50') }}</p>
            <p>{{ $t('privacyAgreement.p51') }}</p>
            <p>{{ $t('privacyAgreement.p52') }}</p>
            <div>{{ $t('privacyAgreement.p53') }}</div>
            <p>{{ $t('privacyAgreement.p54') }}</p>
            <p>{{ $t('privacyAgreement.p55') }}</p>
            <p>{{ $t('privacyAgreement.p56') }}</p>
            <p>{{ $t('privacyAgreement.p57') }}</p>
            <p>{{ $t('privacyAgreement.p58') }}</p>
            <p>{{ $t('privacyAgreement.p59') }}</p>
            <p>{{ $t('privacyAgreement.p60') }}</p>
            <h4>{{ $t('privacyAgreement.p61') }}</h4>
            <p>{{ $t('privacyAgreement.p62') }}</p>
            <p>{{ $t('privacyAgreement.p63') }}</p>
            <p>{{ $t('privacyAgreement.p64') }}</p>
            <p>{{ $t('privacyAgreement.p65') }}</p>
            <p>{{ $t('privacyAgreement.p66') }}</p>
            <h4>{{ $t('privacyAgreement.p67') }}</h4>
            <p>{{ $t('privacyAgreement.p68') }}</p>
            <p>{{ $t('privacyAgreement.p69') }}</p>
            <p>{{ $t('privacyAgreement.p70') }}</p>
            <p>{{ $t('privacyAgreement.p71') }}</p>
            <p>{{ $t('privacyAgreement.p72') }}</p>
            <p>{{ $t('privacyAgreement.p73') }}</p>
            <h4>{{ $t('privacyAgreement.p74') }}</h4>
            <p>{{ $t('privacyAgreement.p75') }}</p>
            <h4>{{ $t('privacyAgreement.p76') }}</h4>
            <p>{{ $t('privacyAgreement.p77') }}</p>
            <p>{{ $t('privacyAgreement.p78') }}</p>
            <p>{{ $t('privacyAgreement.p79') }}</p>
            <p>{{ $t('privacyAgreement.p80') }}</p>
            <p>{{ $t('privacyAgreement.p81') }}</p>
            <p>{{ $t('privacyAgreement.p82') }}</p>
            <p>{{ $t('privacyAgreement.p83') }}</p>
            <p>{{ $t('privacyAgreement.p84') }}</p>
            <p>{{ $t('privacyAgreement.p103') }}</p>
            <p>{{ $t('privacyAgreement.p104') }}</p>
            <p>{{ $t('privacyAgreement.p108') }}</p>
            <p>{{ $t('privacyAgreement.p109') }}</p>
            <p>{{ $t('privacyAgreement.p85') }}</p>
            <p>{{ $t('privacyAgreement.p86') }}</p>
            <p>{{ $t('privacyAgreement.p87') }}</p>
            <p>{{ $t('privacyAgreement.p88') }}</p>
            <p>{{ $t('privacyAgreement.p89') }}</p>
            <p>{{ $t('privacyAgreement.p90') }}</p>
            <p>{{ $t('privacyAgreement.p91') }}</p>
            <p>{{ $t('privacyAgreement.p92') }}</p>
            <p>{{ $t('privacyAgreement.p93') }}</p>
            <p>{{ $t('privacyAgreement.p94') }}</p>
            <p>{{ $t('privacyAgreement.p95') }}</p>
            <p>{{ $t('privacyAgreement.p110') }}</p>
            <p>{{ $t('privacyAgreement.p111') }}</p>
            <p>{{ $t('privacyAgreement.p112') }}</p>
            <h4>{{ $t('privacyAgreement.p96') }}</h4>
            <p>{{ $t('privacyAgreement.p97') }}</p>
            <p>{{ $t('privacyAgreement.p98') }}</p>
            <p>{{ $t('privacyAgreement.p99') }}</p>
            <p>{{ $t('privacyAgreement.p100') }}</p>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'privacyAgreement',
    data() {
        return {
            theme: 'light'
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
    }
}
</script>

<style scoped>

.content {
    margin: 0 15px;
    color: var(--text-color-1);
    font-size: 16px;
}

p {
    text-indent: 2em;
    word-break: break-all;
}

</style>


// WEBPACK FOOTER //
// src/views/my/05privacyAgreement.vue